export default __webpack_public_path__ + "static/media/narrationGirl.449ac867.png";